export const GRADUATION_REQUIREMENT_TYPES = [
  'Mastery in all Core Competencies',
  'Mastery in Two or More Advanced Competencies',
  'Core Classes, 9th grade',
  'Core Classes, 10th grade',
  'Core Classes, 11th grade',
  'Core Classes, 12th grade',
  'Final Portfolio Defense: STEM Research',
  'Final Portfolio Defense: Non-STEM Research',
  'Final Portfolio Defense: Entrepreneurship',
  'Final Portfolio Defense: Service',
  'Final Portfolio Defense: Creative',
  'Minimum 4 Dual Enrollment Classes',
  'Community Service (40 hours per year), 9th grade',
  'Community Service (40 hours per year), 10th grade',
  'Community Service (40 hours per year), 11th grade',
  'Community Service (40 hours per year), 12th grade',
  '80 hours Work Experience',
  'Physical Activity (100 hours per year), 9th grade',
  'Physical Activity (100 hours per year), 10th grade',
  'Physical Activity (100 hours per year), 11th grade',
  'Physical Activity (100 hours per year), 12th grade',
  'Leadership Roles, 9th grade',
  'Leadership Roles, 10th grade',
  'Leadership Roles, 11th grade',
  'Leadership Roles, 12th grade',
  'Cultural Proficiency',
  'Summer Intensive, 9th grade',
  'Summer Intensive, 10th grade',
  'Summer Intensive, 11th grade',
  'Summer Intensive, 12th grade',
];


